import { normaliseDateRange } from '@packages/rate-plans/utils/currentSubscription';

export function normaliseSubscriptionItem(item = {}) {
    if (!item || typeof item !== 'object') {
        return item;
    }

    const dateRange = normaliseDateRange(
        item.date_range || {
            start: item.start_date ?? null,
            end: item.end_date ?? null
        }
    );

    return {
        ...item,
        billing_group_id: item.billing_group_id ?? item.billing_group?.id ?? null,
        rate_plan_id: item.rate_plan_id ?? item.rate_plan?.id ?? null,
        adviser_id: item.adviser_id ?? item.adviser?.id ?? null,
        date_range: dateRange,
        subscription_type: item.subscription_type || item.rate_plan_type || null,
        investors_count: item.investors_count ?? item.billing_group?.investors_count ?? null
    };
}

export default normaliseSubscriptionItem;
